// import Client from './api';
import axios from 'axios';
import { BASE_URL } from './api';
import { saveAs } from 'file-saver';


// axios.interceptors.response.use(function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response;
//   }, function (error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     console.log('error found in interceptors')
//     return Promise.reject(error);
//   });
// export function getCompanies() {
//     const response = Client.get('companies/')
//     console.log(response)
//     return response.data.results
// }

export async function getCompanies(payload) {
    // console.log('getting companies', payload.token)
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
        signal: payload.signal,
    }).then((response) => {
        // console.log('Finished Running: getCompanies async call', response);
        return {
            "companies": response.data.results,
            "count": response.data.count,
            "next": response.data.next,
            "prev": response.data.previous,
            "page": response.data.page,
            "pageSize": response.data.page_size,
            "num_pages": response.data.num_pages,
            // count/num_pages are floors, not totals, when this is set — the
            // backend caps its COUNT() for speed.
            "count_is_capped": response.data.count_is_capped
        };
    }).catch((error) => {
        // A cancelled request is expected when a newer load supersedes this one —
        // swallow it quietly; the caller's request-id guard discards the result.
        if (axios.isCancel(error)) return
        console.log(error)
    });
}

export async function getCompaniesByQueryParams(token, queryParams, signal) {
    // console.log('getting companies', payload.token)
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
        signal,
    }).then((response) => {
        // console.log('Finished Running: getCompanies async call', response);
        return response
    }).catch((error) => {
        // A cancelled request is expected when a newer load supersedes this one —
        // swallow it quietly; the caller's request-id guard discards the result.
        if (axios.isCancel(error)) return
        console.log(error)
    });
}

export async function getResearchCompanies(token, queryParams) {
    // console.log('getting companies', payload.token)
    return axios({
        method: 'get',
        url: `${BASE_URL}/research-companies${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        // console.log('Finished Running: getCompanies async call', response);
        return response
    }).catch((error) => {
        console.log(error)
    });
}

export async function getCompanyByID(payload) {
    // console.log('getting companies', payload.token)
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/${payload.companyId}/`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
    }).then((response) => {
        // console.log('Finished Running: getCompanies async call', response);
        return {
            response
        };
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function getPWACompanies(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/pwa_companies${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
        signal: payload.signal,
    }).then((response) => {
        return {
            "companies": response.data.results,
            "count": response.data.count,
            "next": response.data.next,
            "num_pages": response.data.num_pages,
            "count_is_capped": response.data.count_is_capped
        };
    }).catch((error) => {
        if (axios.isCancel(error)) return
        console.log(error)
    });
}

export async function getPWACompanyByID(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/pwa_companies/${payload.companyId}/`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
        timeout: payload.timeout,
    }).then((response) => {
        return {
            response
        };
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function generateCompanyCRMSummary(companyId, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/companies/${companyId}/ai_crm_summary/`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}

// Distinct makes among PMAs linked to a Company (powers the make
// accordions inside the Company modal's PMAs tab).
export async function getCompanyPMAMakes(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/${payload.companyId}/pma_makes/`,
        headers: {
            'Authorization': `Token ${payload.token}`,
        },
    })
    .then((response) => ({
        makes: response.data.results,
        noMakeCount: response.data.no_make_count || 0,
        total: response.data.total || 0,
    }))
    .catch((error) => { throw error });
}

// Paginated PMAs inside one make for one Company. Same response shape
// as getPMACompanyMakePMAs so a shared make-row UI can consume either.
export async function getCompanyPMAMakePMAs(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/${payload.companyId}/pma_make_pmas/${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`,
        },
    })
    .then((response) => ({
        approvals: response.data.results,
        count: response.data.count,
        next: response.data.next,
        prev: response.data.previous,
        page: response.data.page,
        page_size: response.data.page_size,
        num_pages: response.data.num_pages,
    }))
    .catch((error) => { throw error });
}

export async function getClientAppendix(clientId, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/client_appendix/`,
        params: { client: clientId },
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function getDLACompanies(payload) {
    // console.log('getting companies', payload.token)
    return axios({
        method: 'get',
        url: `${BASE_URL}/dla_companies${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
    }).then((response) => {
        // console.log('Finished Running: getDLACompanies async call', response);
        return {
            "companies": response.data.results,
            "count": response.data.count,
            "next": response.data.next,
            "prev": response.data.previous,
            "page": response.data.page,
            "pageSize": response.data.page_size,
            "num_pages": response.data.num_pages
        };
    }).catch((error) => {
        console.log(error)
    });

}

// Shared by the outreach dashboard's per-card endpoints below: all of them
// scope by CompanyFilter's campaign/client_drf multi-select filters. Array
// filters are serialized as repeated params (campaign=1&campaign=2) to match
// the DRF ModelMultipleChoiceFilter backend.
function getOutreachDashboardAction(action, token, params = {}) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/${action}/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        params: params,
        paramsSerializer: (rawParams) => {
            const sp = new URLSearchParams()
            Object.entries(rawParams).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((item) => sp.append(key, item))
                } else if (value !== undefined && value !== null && value !== '') {
                    sp.append(key, value)
                }
            })
            return sp.toString()
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}

// One row per company: { id, company_name, current_bucket, contacted,
// responded, not_interested }. Powers the Total/Contacted/Responded/
// Not-Interested KPI card -- the frontend derives all four counts from this
// one list instead of four separate round trips.
export async function getOutreachDashboardCompanies(token, params = {}) {
    return getOutreachDashboardAction('outreach_dashboard_companies', token, params)
}

// Emails Sent donut: { 'Email 1': n, 'Email 2': n, 'Email 3': n, 'Email 4': n }.
export async function getOutreachDashboardEmailsSent(token, params = {}) {
    return getOutreachDashboardAction('outreach_dashboard_emails_sent', token, params)
}

// Open and overdue next actions: { open_actions: [...], overdue_actions: [...] }
export async function getOutreachDashboardActions(token, params = {}) {
    return getOutreachDashboardAction('outreach_dashboard_actions', token, params)
}

// CRM action history for trend chart: [{ id, company_name, action_events: [[date, action], ...] }, ...]
export async function getOutreachDashboardCRMActionHistory(token, params = {}) {
    return getOutreachDashboardAction('outreach_dashboard_crm_action_history', token, params)
}

// Email flow Sankey chart: [{ from, to, count }, ...]
export async function getOutreachDashboardEmailFlow(token, params = {}) {
    return getOutreachDashboardAction('outreach_dashboard_email_flow', token, params)
}

// Outreach-scoped companies: only those reached via outreach drafts
export async function getOutreachDashboardCompaniesOutreachScoped(token, params = {}) {
    return getOutreachDashboardAction('outreach_dashboard_companies_outreach_scoped', token, params)
}

// Outreach-scoped emails sent: counts from outreach drafts only
export async function getOutreachDashboardEmailsSentOutreachScoped(token, params = {}) {
    return getOutreachDashboardAction('outreach_dashboard_emails_sent_outreach_scoped', token, params)
}

export async function getCRMSummary(filters, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_crm_summary${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then(response => {
        return {
            "crmStatuses": response.data.crm_selections_dict,
            "crmNextActions": response.data.crm_next_actions_dict
        }
    }).catch((error) =>{
        console.log(error)
    })
}

export async function getCRMSummaries(filters, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_crm_summary${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then(response => response).catch((error) =>{
        console.log(error)
    })
}

export async function exportToCSV(filters, token, fields=null) {
    // console.log('field in axios call', fields)
    let jobData = null
    if(fields){
        jobData = JSON.stringify({
            data: {
                parameter_data: [
                    {
                        id: 9,
                        parameter_value_string: fields
                    }
                ]
            }
        })
    }
    // console.log('job data', jobData)
    return axios({
        method: 'post',
        url: `${BASE_URL}/companies/export_to_csv/${filters}`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: jobData,
        // responseType: 'blob'
    }).then((response) => {
        console.log('response csv', response)
        return response
    }).catch(async (error) =>{
        console.log(error)
        alert(error.response.data.detail)
        return error
    })
}

export async function getPDFTierView(filters, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/pdf_tier_view${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then(response => {
        return response.data
    }).catch((error) =>{
        console.log(error)
    })
}

export async function getCampaignActivitiesSummary(filters, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/campaign_activities_summary${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then(response => {
        return response.data
    }).catch((error) => {
        console.log(error)
    })
}

export async function updateCompany(companyId, formData, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function updateCrmNextAction(companyId, formData, token, { timeout } = {}) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/update_next_action/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: formData,
        timeout,
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function updateCrmNextActionAndAddEvent(companyId, data, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/update_next_action_and_add_event/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}


export async function createCompany(formData, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/companies/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        // console.log('response', response)
        return response
    }).catch((error) => {
        // console.log('error', error)
        return error
    })
}

export async function assignCampaign (campaignId, campaignChangeRequestReason, companyId, token) {
    // console.log("campaign id", campaignId)
    let data = JSON.stringify({
        campaign: null
    })
    if(campaignId){
        data = JSON.stringify({
        campaign: campaignId,
        change_request_reason: campaignChangeRequestReason
        })
    }
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/assign_to_campaign/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function assignCollectionTag (collectionTagName, companyId, token) {
    // console.log("collection tag name", collectionTagName)
    let data = JSON.stringify({
        payload: collectionTagName
    })
    // if(collectionTagName){
    //     data = JSON.stringify({
    //         payload: collectionTagName
    //     })
    // }
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/assign_collection_tag/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function removeCollectionTag (collectionTagId, companyId, token) {
    // console.log("collection tag id", collectionTagId)
    let data = JSON.stringify({
        payload: null
    })
    if(collectionTagId){
        data = JSON.stringify({
        payload: collectionTagId
        })
    }
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/remove_collection_tag/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function transferCollectionTag (currentCollection, newCollection, companyId, token) {
    // console.log("collection tag id", currentCollection)
    let data = JSON.stringify({
        payload: null
    })
    if(currentCollection && newCollection){
        data = JSON.stringify({
            current_collection_name: currentCollection,
            new_collection_name: newCollection
        })
    }
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/transfer_collection_tag/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function vetURL(companyId, action, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/vet_url/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'action': action
        }
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function performBulkAction(token, companyIds, endpoint, payload) {
    // console.log(payload)
    // console.log(payload)
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${endpoint}/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'company_ids': companyIds,
            'payload': payload
        }
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function performBulkActionOnQuery(token, payload, endpoint, filters) {
    // console.log(payload)
    // console.log(payload)
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${endpoint}/${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: payload
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function bulkAssignQueryResultsToCollectionTag(collectionTagName, filters, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/bulk_assign_query_results_to_collection_tag/${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'collection_tag_name': collectionTagName,
        }
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function bulkAssignQueryResultsToCollectionTagAndDeletePreviousCollections(collectionTagName, filters, collectionsToDelete, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/bulk_assign_query_results_to_collection_tag_and_delete_previous_collections/${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'collection_tag_name': collectionTagName,
            'collections_to_delete': collectionsToDelete,
        }
    })
    .then(response => response)
    .catch(error => alert(error))    
}

export async function promoteOrDemoteResearch(companyId, action, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/promote_or_demote_research/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'action': action
        }
    })
    .then(response => response)
    .catch((error) => {
        console.log('error', error)
        alert(error.response.data.detail)
    })
}

export async function getZoomInfoId(companyId, token) {
    // console.log('getZoomInfoId')
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/get_zoom_info_id/`,
        headers: {
            'Authorization': `Token ${token}`
        },
    })
    .then(response => response)
    .catch(error => {
        console.log(error)
        alert(error)
    })
}

export async function clearZoomInfo(companyId, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/clear_zoom_info/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => response)
    .catch(error => error)
}

export async function getZoomInfoBasic(companyId, token) {
    // console.log('getZoomInfoBasic service')
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/enrich_zoom_info_company/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => response)
    .catch(error => error)
}

export async function transferZoomInfoBasic(companyId, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/transfer_zi_basic/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => response)
    .catch(error => alert(error))    
}

export async function assignZoomInfoID(companyId, zoomInfoId, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/assign_zoom_info_id/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'zoom_info_id': zoomInfoId
        }
    })
    .then(response => response)
    .catch(error => alert(error))  
}

export async function markTier(companyId, tierId, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/mark_tier/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'tier_id': tierId
        }
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function markClientFeedback(companyId, clientFeedback, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/mark_client_feedback/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'client_feedback': clientFeedback
        }
    })
    .then(response => response)
    .catch(error => alert(error))
}

// Adds a feedback row to the company's history against its current campaign.
// A blank feedback clears the company's client_feedback.
export async function createCompanyClientFeedback(companyId, feedback, token) {
    return axios({
        method: "post",
        url: `${BASE_URL}/company_client_feedback/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'company': companyId,
            'feedback': feedback
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function updateCompanyClientFeedbackNote(noteId, notes, token) {
    return axios({
        method: 'patch',
        url: `${BASE_URL}/company_client_feedback_notes/${noteId}/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: { notes }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

// Records feedback given in the past: recordedOn is a 'YYYY-MM-DD' date, and campaignId one the
// company has been in
export async function createPastCompanyClientFeedback(companyId, campaignId, feedback, recordedOn, token) {
    return axios({
        method: "post",
        url: `${BASE_URL}/company_client_feedback/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'company': companyId,
            'campaign_id': campaignId,
            'feedback': feedback,
            'recorded_on': recordedOn
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function getClientAppendixPublications(clientId, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/client_appendix_publications/`,
        params: { client: clientId },
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function getClientAppendixPublication(publicationId, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/client_appendix_publications/${publicationId}/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function createClientAppendixPublication(clientId, note, columnLabels, groupByTier, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/client_appendix_publications/`,
        data: { client: clientId, note, column_labels: columnLabels, group_by_tier: groupByTier },
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function deleteClientAppendixPublication(publicationId, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/client_appendix_publications/${publicationId}/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function deleteCompanyClientFeedback(feedbackId, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/company_client_feedback/${feedbackId}/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function deleteCompanyClientFeedbackNote(noteId, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/company_client_feedback_notes/${noteId}/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

// Pulls the first message out of a failed feedback/note create, e.g. the
// campaign_id error when the company is not in a campaign.
export function clientFeedbackErrorMessage(result) {
    const errors = result && result.response && result.response.data
    if (errors && typeof errors === 'object') {
        const first = Object.values(errors)[0]
        return Array.isArray(first) ? first[0] : String(first)
    }
    return 'Unable to record client feedback.'
}

// Same call shape as updateCompany so BaseEditTextArea can use it: formData is a
// JSON string of {notes}. Each save adds a note row against the company's campaign.
export async function createCompanyClientFeedbackNote(companyId, formData, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/company_client_feedback_notes/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: { company: companyId, ...JSON.parse(formData) }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function getMostRecentCrmStatus(filters, token){
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/get_current_crm_statuses${filters}`,
        headers: {
            "Authorization": `Token ${token}`
        }
    })
    .then(response => response.data)
    .catch(error => console.error)
}

export async function addNewCrmStatus(companyId, crmStatusId, token, { timeout, silent } = {}) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/assign_new_crm_status/`,
        headers: {
            "Authorization": `Token ${token}`
        },
        data: {
            'crm_id': crmStatusId
        },
        timeout,
    })
    .then(response => response)
    .catch(error => silent ? console.log(error) : alert(error))
}

export async function removeCrmStatus(companyId, companyCrmStatusId, token) {
    return axios({
        method: "delete",
        url: `${BASE_URL}/companies/${companyId}/remove_crm_status/${companyCrmStatusId}/`,
        headers: {
            "Authorization": `Token ${token}`
        }
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function addNewCrmAction(companyId, actionData, token, { timeout, silent } = {}) {
    return axios({
        method: "put",
        url: `${BASE_URL}/companies/${companyId}/add_new_crm_action/`,
        headers: {
            "Authorization": `Token ${token}`
        },
        data: {
            "crm_action": actionData
        },
        timeout,
    })
    .then(response => response.data)
    .catch(error => silent ? console.log(error) : alert(error))
}

export async function createMultipleCompanies(data, token){
    return axios({
        method: "post",
        url: `${BASE_URL}/companies/create_multiple_companies/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}

export async function getCampaignValidCompanies(token, clientId){
    // console.log(clientId);
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/get_campaign_valid_companies/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        params: {
            client_id: clientId
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}

export async function getCompanyHistory(token, companyId, numberOfChanges){
    // console.log(clientId);
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/${companyId}/get_company_history/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        params: {
            'count': numberOfChanges
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}

export async function getContractsAndSubContracts(token, companyId){
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/${companyId}/get_contracts_and_subcontracts/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}

export async function getCampaignChangeReport(token){
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/campaign_change_report`,
        headers: {
            "Authorization": `Token ${token}`
        }
    })
    .then(response => response.data)
    .catch(error => console.error)
}

export async function getCRMSummaryStageCounts(filters, token, client_id=null){
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/get_crm_summary_stages${filters}`,
        headers: {
            "Authorization": `Token ${token}`
        },
        params: {
            'client_id': client_id
        }
    })
    .then(response => response)
    .catch(error => console.error)
}

export async function getDescriptions(token, companyId) {
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/${companyId}/get_descriptions`,
        headers: {
            "Authorization": `Token ${token}`
        }
    })
    .then(response => response.data)
    .catch(error => console.error)
}

export async function getCRMResolutionCompanies(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/crm_resolution_companies/${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
    }).then((response) => {
        // console.log(response)
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function resolveCRMActions(payload) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/crm_resolution_companies/${payload.companyId}/update_crm_actions/`,
        headers: {
            'Authorization': `Token ${payload.token}`,
            'Content-Type': 'application/json'
        },
        data: payload.formData
    }).then((response) => {
        // console.log(response)
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function updateCompanyCRMActions(payload) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${payload.companyId}/update_crm_actions/`,
        headers: {
            'Authorization': `Token ${payload.token}`,
            'Content-Type': 'application/json'
        },
        data: payload.formData
    }).then((response) => {
        // console.log(response)
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}


export async function getCRMReportingCompanies(payload) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/crm_reporting_companies/${payload.endpoint}`,
        headers: {
            'Authorization': `Token ${payload.token}`
        },
    }).then((response) => {
        // console.log(response)
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function getHighPriorityCompanies(token, queryParams){
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/get_high_priority_companies/?${queryParams}`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })

}

export async function getCrmSpreadsheetCompanies(token, queryParams){
    return axios({
        method: "get",
        url: `${BASE_URL}/companies/get_crm_spreadsheet_view_companies/?${queryParams}`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })

}

// export async function bulkSaveCRMReportedEvents(token, companyEventData) {
//     return axios({
//         method: 'put',
//         url: `${BASE_URL}/crm_reporting_companies/bulk_set_reported_events/`,
//         headers: {
//             'Authorization': `Token ${token}`
//         },
//         data: {
//             'company_event_data': companyEventData
//         }
//     }).then((response) => {
//         // console.log(response)
//         return response
//     }).catch((error) => {
//         console.log(error)
//         return error
//     });
// }

export async function bulkSaveCRMTargetList(token, companyEventData, companyProgressUpdateData) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/crm_reporting_companies/bulk_save_target_list/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: {
            'company_event_data': companyEventData,
            'company_progress_update_data': companyProgressUpdateData
        }
    }).then((response) => {
        console.log(response)
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function getResearchDashboardData(token){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_research_dashboard_data/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function getAdminDashboardData(token){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_admin_dashboard_data/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response.data
    });
}

export async function getAdminDashboardExportDetail(token){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_admin_dashboard_export_detail/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response.data
    });
}

export async function getAdminDashboardAppUsageDetail(token){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_admin_dashboard_app_usage_detail/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response.data
    });
}

export async function getAdminDashboardResponsiveness(token){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_admin_dashboard_responsiveness/`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response.data
    });
}

export async function getCompaniesForManualUrlAndZoomInfoResearch(token, queryParams){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_companies_for_manual_url_and_zoom_info_research/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function getCompaniesForManualUrlVetting(token, queryParams){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_companies_for_manual_url_vetting/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function saveCompaniesForManualUrlAndZoomInfoResearch(token, data){
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/save_url_and_zoom_info_changes/`,
        headers : {
            'Authorization': `Token ${token}`
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function saveCompaniesForManualUrlVetting(token, data){
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/save_vet_url_changes/`,
        headers : {
            'Authorization': `Token ${token}`
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function addOrRemoveCRMSpreadsheetUser(token, data, companyId){
    return axios({
        method: 'put',
        url: `${BASE_URL}/companies/${companyId}/add_or_remove_crm_spreadsheet_user/`,
        headers : {
            'Authorization': `Token ${token}`
        },
        data: data
    }).then((response) => {
        return response
    }).catch(error => error)
}

export async function getCompanySpiderQueueLength(token){
    return axios({
        method: 'get',
        url: `${BASE_URL}/companies/get_company_spider_queue_length/`,
        headers : {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch(error => error)
}

export async function bulkEditCompanies(token, data){
    return axios({
        method: 'patch',
        url: `${BASE_URL}/companies/bulk_edit/`,
        headers : {
            'Authorization': `Token ${token}`
        },
        data: data
    }).then((response) => {
        return response
    }).catch(error => error)
}
